import React from "react";
import { Form, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatNumberOnDashBoard } from "../../../helper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getDownloadMinistryState,
  clearDownloadMinistryStateAction
} from "../../../actions/dowloadExcelActions";
import { DownloadExcelReport } from "../../reusableComponent";
import { remove } from "lodash";
import InformationIcon from "../../../assets/information-icon.svg";
import { Image } from "react-bootstrap";
import NoDataFound from "../../../component/NoDataFound";

export class IssueStateReportComponent extends React.Component {
  state = {
    downloadOnlyIssueDetails: []
  };

  onDownload = (id, index) => {
    let { downloadOnlyIssueDetails } = this.state;
    const { getDownloadMinistryState } = this.props;
    let payload = {
      groupId: id,
      issueDetailsOnly: downloadOnlyIssueDetails.includes(index) ? true : false
    };
    getDownloadMinistryState(undefined, payload);
  };

  onChangeDownloadOnlyIssueDetails = index => {
    let { downloadOnlyIssueDetails } = this.state;
    if (downloadOnlyIssueDetails.includes(index)) {
      let array = downloadOnlyIssueDetails;
      remove(array, function(e) {
        return e === index;
      });
      this.setState({ downloadOnlyIssueDetails: array });
    } else {
      this.setState(prevState => ({
        downloadOnlyIssueDetails: [...prevState.downloadOnlyIssueDetails, index]
      }));
    }
  };

  render() {
    //
    const {
      onDownload,
      props: { misData, ministryStateReducer, clearDownloadMinistryStateAction }
    } = this;

    return (
      <>
        <div className="information-icon">
          <Image src={InformationIcon} />
          Select the checkbox to download detailed agenda
        </div>
        <Table striped size="sm" className="mis-project-list">
          <thead>
            <tr>
              <th className="ministry-title-column">Ministry/State</th>
              <th className="ministry-project-column">Project Count</th>
              <th className="ministry-issue-column">Total Issues</th>
              <th className="ministry-issue-column">Resolved Issues</th>
              <th className="ministry-issue-column">Pending Issues</th>
              <th className="ministry-cost-column">Project Cost</th>
              <th className="ministry-attachment-column">Attachments</th>
            </tr>
          </thead>
          <tbody>
            {misData && misData.data && misData.data.length > 0 ? (
              misData.data.map((data, index) => {
                const { isLoading, downloadingSrc } =
                  ministryStateReducer[data.groupId] || {};
                return (
                  <tr key={index}>
                    <td className="ministry-title-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.groupName}
                          </Tooltip>
                        }
                      >
                        <div>{data.groupName}</div>
                      </OverlayTrigger>
                    </td>
                    <td className="ministry-project-column">
                      {data.projectCount}
                    </td>
                    <td className="ministry-issue-column">{data.number}</td>
                    <td className="ministry-issue-column">
                      {data.issueResolved}
                    </td>
                    <td className="ministry-issue-column">
                      {data.issuePending}
                    </td>
                    <td className="ministry-cost-column">
                      {data.projectCost
                        ? formatNumberOnDashBoard(data.projectCost)
                        : ""}
                    </td>
                    <td className="ministry-attachment-column">
                      <div className="report-only-download-box visible">
                        <Form.Check
                          type="checkbox"
                          label="Download Detailed Agenda"
                          className="download-check-box visible"
                          onChange={() => {
                            this.onChangeDownloadOnlyIssueDetails(index);
                          }}
                        />
                        <DownloadExcelReport
                          isLoading={isLoading}
                          downloadLink={downloadingSrc}
                          onClearDownload={() =>
                            clearDownloadMinistryStateAction(data.groupId)
                          }
                          onStartDownloading={() =>
                            onDownload(data.groupId, index)
                          }
                          iconClassName="doc-icon"
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ministryStateReducer: state.donwloadExcelReducer.ministryState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadMinistryState,
      clearDownloadMinistryStateAction
    },
    dispatch
  );
}

const IssueStateReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueStateReportComponent);
export default IssueStateReport;
